import SessionAnnotationModal from './SessionAnnotationModal';

export default SessionAnnotationModal;
